export enum ReportKind {
    ByProject,
    ByUser
}